<template>
  <v-toolbar dense :color="$store.state.sysBackgroundColor">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon @click="ejecutarAccion('Cerrar')" v-on="on">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>
      <span>Volver</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-toolbar-title class="overline">{{ titulo }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-speed-dial open-on-hover direction="left">
      <template v-slot:activator>
        <v-btn color="primary" icon @click="ejecutarAccion('Imprimir')">
          <v-icon>
            print
          </v-icon>
        </v-btn>
      </template>
      <v-btn icon color="green" @click="ejecutarAccion('ExportarXls')">
        <v-icon>mdi-file-excel</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="ejecutarAccion('Inicializar')">
          <v-icon>undo</v-icon>
        </v-btn>
      </template>
      <span>Reiniciar</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
export default {
  name: "EncabezadoReporte",
  props: {
    titulo: String,
    accion: String
  },
  methods: {
    ejecutarAccion(accion) {
      if (accion == "Cerrar") this.$router.go(-1);
      else {
        this.$emit("ejecutarAccion", accion);
      }
    }
  }
};
</script>
